import React, { ComponentProps, FC } from 'react';
import CustomDropDown from './custom-dropdown';
import DefaultDropdown from './default-dropdown';
import Select from './option-dropdown';

export interface Option {
  name: string;
  value: string | number;
}

export interface DropdownProps extends Omit<ComponentProps<'select'>, 'key'> {
  error?: boolean;
  className?: string;
  containerClassName?: string;
  labelClassName?: string;
  items?: Array<{ label: string; value: string }>;
  label?: string;
  value?: string;
  defaultValue?: string;
  customButtonElement?: JSX.Element;
  customButtonClassNames?: (open?: boolean) => string | string;
  extraButtonClassName?: string;
  customMenuClassNames?: (open?: boolean) => string;
  customMenuWrapperClassNames?: string;
  selectDropdownClassNames?: string;
  selectDefaultValue?: Option;
  selectOptions?: Option[];
  selectOnChange?: (option: Option) => void;
  disabled?: boolean;
  selectedValue?: string | number;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  /** Custom-button dropdowns only: keep the closed menu in the DOM (hidden), e.g. so its links are crawlable. */
  keepMenuMounted?: boolean;
}

const Dropdown: FC<DropdownProps> = ({
  error,
  className = '',
  containerClassName = '',
  labelClassName,
  label,
  items,
  onChange,
  value,
  customButtonElement,
  customButtonClassNames,
  extraButtonClassName,
  customMenuClassNames,
  customMenuWrapperClassNames,
  selectDropdownClassNames,
  selectDefaultValue,
  selectOptions,
  selectOnChange,
  children,
  disabled,
  selectedValue,
  isOpen,
  onOpenChange,
  keepMenuMounted,
  ...props
}) => {
  return (
    <>
      {customButtonElement ? (
        <CustomDropDown
          buttonElement={customButtonElement}
          buttonClassNames={customButtonClassNames}
          extraButtonClassName={extraButtonClassName}
          menuClassNames={customMenuClassNames}
          menuWrapperClassNames={customMenuWrapperClassNames}
          disabled={disabled}
          isOpen={isOpen}
          onOpenChange={onOpenChange}
          keepMenuMounted={keepMenuMounted}
        >
          {children}
        </CustomDropDown>
      ) : selectOptions ? (
        <Select
          error={error}
          label={label}
          labelClassName={labelClassName}
          selectButtonClassName={selectDropdownClassNames}
          defaultValue={selectDefaultValue}
          options={selectOptions}
          onChange={selectOnChange}
          required={props.required}
          disabled={disabled}
          selectedValue={selectedValue}
          isOpen={isOpen}
          onOpenChange={onOpenChange}
        />
      ) : (
        <DefaultDropdown
          className={className}
          containerClassName={containerClassName}
          labelClassName={labelClassName}
          label={label}
          items={items ?? []}
          onChange={onChange}
          value={value}
          {...props}
        />
      )}
    </>
  );
};

export default Dropdown;
